export const versionsPageTranslationsPl = {
    uploading: 'Ładowanie pliku...',
    versionsCopyLink: 'Kopiuj link',
    versionsDownloadLatestVersion: 'Pobierz najnowszą wersje',
    versionsNoSqlVersion: 'Pobierz wersje bez SQLa',
    versionsFullVersion: 'Pobierz pełną wersje',
    versionsPage: 'Wersje',
    versionsName: 'Nazwa pliku',
    versionsVersion: 'Wersja',
    versionsVersionMajor: 'Wersja główna',
    versionsVersionMinor: 'Wersja podrzędna',
    versionsVersionPatch: 'Wersja aktualizacji',
    versionsReleaseDate: 'Data wydania',
    versionsReleaseType: 'Typ',
    versionsPatchNotes: 'Informacje o aktualizacji',
    versionsMd5: 'Suma kontrolna MD5',
    versionsSha256: 'Suma kontrolna SHA256',
    versionsAddVersion: 'Dodaj wersje',
    versionsUpdateVersion: 'Edytuj wersje',
    versionsDownload: 'Pobierz',
    versionsAddFile: 'Wybierz plik',
    usersDeleteVersion: 'Usuń wersje',
    versionsFileNotChoosen: '(nie wybrano pliku)',
    versionsRemoveConfirmationMessage: 'Czy na pewno chcesz usunąć zaznaczone wersje?',
    versionsForLicence: 'Wersje dla licencji',
    versionsDownloadLatest: 'Pobierz najnowszą',
    versionsLicenceFilter: 'Pokaż dla licencji',
    versionsLicenceVersionFilter: 'aktualizacja:',
    versionsShowAll: 'wszystkich',
    versionsBeta: 'Wersja beta',
    versionsVariant: 'Wariant',
    versionsComponent: 'Komponent',
    versionsComponents: 'Komponenty w wydaniu',
    size: 'Rozmiar pliku',
};

export const versionsPageTranslationsEn = {
    uploading: 'Uploading...',
    versionsCopyLink: 'Copy link',
    versionsDownloadLatestVersion: 'Download the latest version',
    versionsNoSqlVersion: 'Download version without SQL',
    versionsFullVersion: 'Download full version',
    versionsPage: 'Versions',
    versionsName: 'File name',
    versionsVersion: 'Version',
    versionsVersionMajor: 'Major version',
    versionsVersionMinor: 'Minor version',
    versionsVersionPatch: 'Patch version',
    versionsReleaseDate: 'Release date',
    versionsReleaseType: 'Type',
    versionsPatchNotes: 'Patch notes',
    versionsMd5: 'MD5 checksum',
    versionsSha256: 'SHA256 checksum',
    versionsAddVersion: 'Add version',
    versionsUpdateVersion: 'Edit version',
    versionsDownload: 'Download',
    versionsAddFile: 'Choose file',
    usersDeleteVersion: 'Delete version',
    versionsFileNotChoosen: '(file not choosen)',
    versionsRemoveConfirmationMessage: 'Are you sure you want to delete the selected versions?',
    versionsForLicence: 'Versions for licenes',
    versionsDownloadLatest: 'Download latest',
    versionsLicenceFilter: 'Show for licences',
    versionsLicenceVersionFilter: 'version:',
    versionsShowAll: 'all',
    versionsBeta: 'Beta version',
    versionsVariant: 'Variant',
    versionsComponent: 'Component',
    versionsComponents: 'Components in the release',
    size: 'File size',
};
